import { ApiaApi, makeApiaUrl } from '@apia/api';
import {
  TActionDispatcherOptions,
  TActionResult,
  TFooter,
  panelActionsEmitter,
} from './usePanelActions';
import { panelNetworkStateEmitter } from './usePanelNetworkState';
import { changePanelTitle } from '../panelsUtil';
import { ucfirst } from '@apia/util';
import { changePanelFooter } from '../splash/panels/PanelContext/usePanelFooter';
import {
  setPanelImageAction,
  setPanelTitleAction,
  setPanelTitleDescritpion,
} from '../panelsUtil/usePanelTitleAction';
import { startTransition } from 'react';
import { TPanelIdentifier } from '../eventsController';

export type TOnSucceed = (hasSucceed: boolean, data: TActionResult) => unknown;

/**
 * **MÉTODO DE USO INTERNO**
 *
 * LLama al server para ejecutar una acción iniciada en el cliente.
 *
 * La forma de llamar acciones desde un panel es con el hook usePanelActions.
 */
export function firePanelAction(
  panelId: string,
  action: string,
  parameters?: Record<string, unknown>,
  options?: TActionDispatcherOptions,
) {
  const postData = { p_action: action, ...parameters };
  panelActionsEmitter.emit(panelId, `pre${ucfirst(action)}`, null);
  void ApiaApi.post(
    makeApiaUrl({
      action: 'panelAction',
      pnlId: panelId,
    }),
    { postData, postDataTreatement: 'stringify', ...options?.requestConfig },
  )
    .then((result) => {
      if (result?.status !== 200) {
        console.log('ERROR', panelId);
        panelNetworkStateEmitter.emit('stateChange', {
          panelId,
          isConnected: false,
        });
      } else {
        panelNetworkStateEmitter.emit('stateChange', {
          panelId,
          isConnected: true,
        });
      }
      try {
        if (result) {
          startTransition(() => {
            if (result?.data?.title) {
              changePanelTitle(
                { panelId } as TPanelIdentifier,
                (result as TActionResult<{ title: string }>)?.data
                  ?.title as string,
              );
            }
            if (result?.data?.footer) {
              changePanelFooter(
                panelId,
                (result as TActionResult<{ footer: TFooter }>)?.data
                  ?.footer as TFooter,
              );
            }
            if (result?.data?.titleAction) {
              setPanelTitleAction(panelId, result?.data?.titleAction as string);
            }

            setPanelImageAction(panelId, (result?.data?.image as string) ?? '');
            if (result?.data?.titleDescription) {
              setPanelTitleDescritpion(
                panelId,
                result?.data?.titleDescription as string,
              );
            }
            options?.onComplete?.(true, result);
            panelActionsEmitter.emit(panelId, action, result);
          });
        } else options?.onComplete?.(false, null);
      } catch (e) {
        console.error(e);
      }
    })
    .catch((e) => {
      console.error(e);
      panelNetworkStateEmitter.emit('stateChange', {
        panelId,
        isConnected: false,
      });
      options?.onComplete?.(false, null);
    });
}
